module.exports = __webpack_public_path__ + "home-block-5-image-28QUHtK.jpg";